<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
    }
  },
  created () {
    var inPageTime = parseInt(new Date().getTime())
    var fromPage = ''
    if (this.$router.history._startLocation.split('/')['2'] !== undefined) {
      fromPage = this.$router.history._startLocation.split('/')['2'].split('?')['0']
    }
    var toPage = this.$router.history.current.name
    var data = {
      'toPage': toPage,
      'fromPage': fromPage,
      'inPageTime': inPageTime,
      'outPageTime': ''
    }
    var datajson = JSON.stringify(data)
    sessionStorage.setItem('pageInfoData', datajson)

    this.trackPageView(toPage)
  }
}
</script>
<style type="text/css">
  /* @import "./assets/font/font.css"; */
  body{
    /* font-family: 'PingFang SC'; */
    font-family: PingFangSCRegular, 'PingFang SC', sans-serif;
  }
  /*loading*/
  /deep/ .el-loading-mask.is-fullscreen{z-index:10010!important;}

  #nprogress{position: fixed !important ;top: 0px !important ;z-index: 10000 !important ;}
  #nprogress .bar {height: 1px; border:none; background: rgba(83, 102, 163, 1) !important ;box-shadow: 10px 0px 10px rgba(83, 102, 163, 1)!important ;}
  #nprogress .peg {box-shadow:10px 0px 10px rgba(83, 102, 163, 1)!important ;}
  #nprogress .spinner-icon {border-top-color: rgb(1,1,1,0) !important ;border-left-color: rgb(1,1,1,0) !important ;}
  .el-scrollbar .el-scrollbar__bar { opacity: 1 !important;}
  .el-drawer {outline: none!important;}
  .mobile-el-message {min-width: 100%;}
  .wechatBindCancelButton {width: 131px;height: 36px;background-color: rgb(83, 146, 249);border: none;border-radius: 6px;box-shadow: none;font-weight: 400;font-size: 16px;color: #FFFFFF;text-align: center;}
  .room-order-tips-info ul{ margin-left:15px !important;}
  .v-modal{z-index: 1990!important;}

  /*不可修改的input底色及字体颜色处理*/
  input:disabled{background-color: #F5F7FA !important;border-color: #E4E7ED !important;color: #C0C4CC !important;cursor: not-allowed;}

  /*登录页面的tab选项卡宽度控制*/
  #loginTabs .el-tabs__nav{width: 100%}
  #loginTabs .el-tabs__item{width: 50% !important;text-align: center}
</style>



// WEBPACK FOOTER //
// src/App.vue